export { default as ArrowRight } from './ArrowRight';
export { default as BurgerIcon } from './BurgerIcon';
export { default as ChatFrame } from './ChatFrame';
export { default as ChevronDown } from './ChevronDown';
export { default as ChevronRight } from './ChevronRight';
export { default as ClockIcon } from './ClockIcon';
export { default as CloseIcon } from './CloseIcon';
export * from './home';
export { default as LocationIcon } from './LocationIcon';
export { default as Logo } from './Logo';
export { default as MedalStarIcon } from './MedalStarIcon';
export { default as MedalStarSolidIcon } from './MedalStarSolidIcon';
export { default as MegaNavFrame } from './MegaNavFrame';
export { default as NavActiveIcon } from './NavActiveIcon';
export { default as NextIcon } from './NextIcon';
export { default as NoteIcon } from './NoteIcon';
export { default as PrevIcon } from './PrevIcon';
export { default as QuoteIcon } from './QuoteIcon';
export { default as SelectedIcon } from './SelectedIcon';
export { default as TimerIcon } from './TimerIcon';

const common = {
	file: '/icons/file.svg',
	globe: '/icons/globe.svg',
	logo: '/icons/logo.svg',
	logoWhite: '/icons/logo-white.svg',
	next: '/icons/next.svg',
	facebook: '/icons/facebook.svg',
	tiktok: '/icons/tiktok.svg',
	zalo: '/icons/zalo.svg',
	vercel: '/icons/vercel.svg',
	window: '/icons/window.svg',
	communityGroup: '/icons/community-group.svg',
};

const header = {
	book: '/icons/header/book.svg',
	navActive: '/icons/header/nav-active.svg',
	navBurger: '/icons/header/nav-burger.svg',
	navClose: '/icons/header/nav-close.svg',
};

const home = {
	dotsFrame: '/icons/home/dots-frame.svg',
	mottoFrame: '/icons/home/motto-frame.svg',
};

export const Icons = {
	common,
	header,
	home,
};
